import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { ApiError, isApiErrorDto } from './error';

@Injectable({ providedIn: 'root' })
export class ApiErrorFactory {
  constructor(private translateService: TranslateService) {}

  async create(httpError: HttpErrorResponse): Promise<ApiError> {
    // A status of zero indicates that the backend is not reachable.
    if (httpError.status === 0) {
      return new ApiError(httpError, this.translateService.instant('ERROR.UNKNOWN'));
    } else if (httpError.status === 401 || httpError.status === 403) {
      return new ApiError(httpError, this.translateService.instant('ERROR.NOT_AUTHORIZED'));
    }

    // Angular's HttpClient does not respect the Content-Type sent by the server in case of an error.
    // In Image or Video Pipes, we request the server content as a Blob, so Angular also assumes that the error is a Blob.
    // In this case, we need to convert the Blob to JSON to get the error message.
    let innerError = httpError.error;
    if (httpError.headers.get('Content-Type') == 'application/json' && httpError.error instanceof Blob) {
      innerError = await new Response(innerError).json();
    }

    const readableMessage = isApiErrorDto(innerError)
      ? this.translateService.instant(`ERROR.KEY.${innerError.key}`)
      : this.translateService.instant('ERROR.UNKNOWN');

    return new ApiError(httpError, readableMessage);
  }
}
